import { combineReducers } from "@reduxjs/toolkit";

import { dataAction, dataReducer, dataState } from "./data";
import { errorsAction, errorsReducer, errorsState } from "./errors";
import { filtersAction, filtersReducer, filtersState } from "./filters";
import {
	customersCounterpartiesDataModalState,
	customersCounterpartiesDataModalReducer,
	customersCounterpartiesDataModalAction,
} from "./dataModal";

export interface StateCounterparty {
	data: dataState;
	errors: errorsState;
	filters: filtersState;
	dataModal: customersCounterpartiesDataModalState;
}

export const counterparty = combineReducers<StateCounterparty>({
	data: dataReducer,
	errors: errorsReducer,
	filters: filtersReducer,
	dataModal: customersCounterpartiesDataModalReducer,
});

export const counterpartyAction = {
	data: dataAction,
	errors: errorsAction,
	filters: filtersAction,
	dataModal: customersCounterpartiesDataModalAction,
};

export default counterparty;
